import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import {
  Breadcrumb,
  Cabecalho,
  ErroLayoutContainer,
  IconeBack,
  Link
} from 'src/componentes'
import { FuncoesDataHora } from 'src/componentes/funcoes'
import {
  Tabela,
  TabelaDados,
  TabelaRef,
  TabelaResposta
} from 'src/componentes/tabela'
import { Api } from 'src/servicos'
import { StatusRescisao, StatusRescisaoPorExtenso } from 'src/tipos'

import { ContainerLink, Dados } from './styles'

export const PaginaHistoricoRescisao: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const history = useHistory()
  const tabelaRef = useRef<TabelaRef>()
  const [numeroProtocolo, definirNumeroProtocolo] = useState('')

  const obterDados = async (): Promise<TabelaResposta | null> => {
    const dados = await Api.ObterHistoricoRescisao(id)
    if (!dados) return null

    definirNumeroProtocolo(dados.numeroProtocolo)
    return { Dados: dados.itens } as TabelaResposta
  }

  useEffect(() => {
    tabelaRef.current?.CarregarDados()
  }, []) //eslint-disable-line

  const traduzirStatus = (status?: string) =>
    status
      ? StatusRescisaoPorExtenso[status as keyof typeof StatusRescisao] ??
        status
      : '—'

  return (
    <>
      <ContainerLink>
        <Link
          texto="Voltar"
          acaoVoltar={() => history.goBack()}
          icone={IconeBack}
        />
      </ContainerLink>
      <Cabecalho>
        <Breadcrumb
          titulo={`Histórico do Protocolo - ${numeroProtocolo}`}
          atalhos={[
            { texto: 'Acadêmico', acao: () => history.goBack() },
            { texto: 'Rescisões', acao: () => history.goBack() },
            { texto: 'Histórico do Protocolo' }
          ]}
        />
      </Cabecalho>
      <Dados>
        <Tabela
          ref={tabelaRef}
          Colunas={[
            {
              Chave: 'nomeUsuario',
              RenderizarCabecalho: () => (
                <div style={{ width: 150 }}>Usuário que Alterou</div>
              )
            },
            {
              Chave: 'statusAnterior',
              Renderizar: (linha: TabelaDados) => (
                <>{traduzirStatus(linha.statusAnterior)}</>
              ),
              RenderizarCabecalho: () => (
                <div style={{ width: 160 }}>Status Anterior</div>
              )
            },
            {
              Chave: 'statusNovo',
              Renderizar: (linha: TabelaDados) => (
                <>{traduzirStatus(linha.statusNovo)}</>
              ),
              RenderizarCabecalho: () => (
                <div style={{ width: 160 }}>Status Atual</div>
              )
            },
            {
              Chave: 'dataHora',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <span>
                  {FuncoesDataHora.dataHoraToLocaleString(linha.dataHora)}
                </span>
              ),
              RenderizarCabecalho: () => (
                <div style={{ width: 120 }}>Data Alteração</div>
              )
            }
          ]}
          ObterDados={obterDados}
        />
      </Dados>
    </>
  )
}

export default (): JSX.Element => (
  <ErroLayoutContainer.Provider>
    <PaginaHistoricoRescisao />
  </ErroLayoutContainer.Provider>
)
